<template>
  <div id="PreviewSmsNotification">
    <div class="header">
      <div class="app-icon">
        <Icon icon="fas fa-comment"/>
      </div>
      <div class="title">
        {{phoneNumber || '1 (800) 555-5555'}}
      </div>
      <div class="time-sent">{{$t('now')}}</div>
    </div>
    <div class="message-text">{{message || $t('Message')}}</div>
  </div>
</template>

<script>

export default {
  name: 'PreviewSmsNotification',
  props: {
    message: String,
    phoneNumber: String
  }
}
</script>

<style lang="scss">
#PreviewSmsNotification {
  width: 315px;
  // height: 100px;
  position: relative;
  font-family: 'Lucida Grande', 'Lucida Sans Unicode', sans-serif;
  background: #EAEAEA;
  border-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(204, 204, 204, .2);

  .header {
    .app-icon {
      font-size:18px;
      position: absolute;
      top: 1px;
      left: 10px;
      color: #FF9700;
      // background: url('../assets/imessage_logo.png') center center no-repeat;
      // background-size: 100%;
    }
    .title {
      color: #858585;
      position: absolute;
      left: 36px;
      top: 5px;
      color: #858585;
      width: 280px;
      height: 14px;
      font-size: 12px;
    }
    .time-sent {
      color: #858585;
      width: 30px;
      height: 14px;
      position: absolute;
      top: 4px;
      font-size: 12px;
      right: 10px;
    }
  }
  // .name {
  //   // position: absolute;
  //   padding: 27px 0px 0px 10px;
  //   font-size: 12px;
  //   font-weight: bold;
  // }
  .message-text {
    width: 293px;
    // padding: 27px 0px 0px 10px;
    margin: 25px 0px 5px 10px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    overflow-wrap: break-word;
    white-space: pre-wrap;
  }
}
</style>
